import { Injectable } from '@angular/core';
import { ApiService } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { Observable } from 'rxjs';
import { Feedback, FeedbackAdminResp, FeedbackStatus } from './feedback.abstraction';

@Injectable({
  providedIn: 'root',
})
export class FeedbackApiService extends ApiService {
  isLoading$ = this._isLoading$;

  readonly #apiController: string = '@api/support/feedbacks';

  getFeedback(feedbackId: number): Observable<Feedback> {
    return this._httpClient
      .get<Feedback>(`${this.#apiController}/${feedbackId}/`)
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  addFeedback(feedbackId: number, feedback: FeedbackAdminResp): Observable<Feedback> {
    return this._httpClient
      .post<Feedback>(`${this.#apiController}/${feedbackId}/provide-response/`, feedback)
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  patchFeedback(feedbackId: number, status: FeedbackStatus): Observable<Feedback> {
    return this._httpClient
      .patch<Feedback>(`${this.#apiController}/${feedbackId}/`, { status })
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }
}
